<template>
  <div>
    <div style="padding-left: 20px">
      <mapa @close="closeMap" v-if="open" :locations="locations" :config="mapConfig">
        <div>
           <span class="title-card-map">
            {{superContato.descricao}}
          </span>
          <span class="text-card-map">
            {{itens.endereco}}
          </span>
        </div>
      </mapa>
    </div>
    <el-row v-if="!open" style="padding-left: 20px">
      <el-card v-if="atendentePrincipal" :style="cardStyle()" class="card-contatos" shadow="never">
        <el-row>
          <el-col style="max-width: 65px" :span="4">
            <div class="align-center">
              <img v-if="atendentePrincipal.linkFoto" style="height: 50px; width: 50px" class="card-contatos-image" :src="atendentePrincipal.linkFoto"/>
              <svg-icone v-if="!atendentePrincipal.linkFoto" style="background: #ffff; border-radius: 50px;" :cor="estilo.aplicacao.corPrimariaAplicacao" :width="50" :height="50" icone="avatar_empty"></svg-icone>
            </div>
          </el-col>
          <el-col :span="9">
            <div class="align-text">
            <span class="card-title">{{parametros.tituloAtendentePrioritario}}</span>
            <span class="card-atendente-text">{{atendentePrincipal.nome}}</span> <br>
            </div>
          </el-col>
          <el-col :span="11">
            <div class="align-buttons">
            <div v-if="agenteRelacionamento.telefone">
                <div style="margin-right: 15px" class="itens" v-if="agenteRelacionamento.telefone">
                <a style="color: #FFFFFF; text-decoration: none" :href="`tel:+${agenteRelacionamento.telefone}`">
                  <el-button :style="botaoStyle()" class="button-actions"><svg-icone icone="icon_mini_phone" :height="15" :cor="'#FFFFFF'"/></el-button>
                  <span :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title">{{agenteRelacionamento.telefone}}</span>
                </a>
              </div>
            </div>
            <div v-if="agenteRelacionamento.whatsapp">
                <div @click="iniciarConversa(agenteRelacionamento.whatsapp)" style="margin-right: 9px; cursor:pointer;"  class="itens" v-if="agenteRelacionamento.whatsapp">
                    <el-button :style="botaoStyle()" class="button-actions"><svg-icone icone="icon_mini_whatsapp" :height="15" :cor="'#FFFFFF'"/></el-button>
                    <span :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title">Conversar</span>
                </div>
              </div>
          </div>
        </el-col>
        </el-row>
      </el-card>
      <el-card v-if="superContato" shadow="never" :style="cardStyle()" class="card-contatos">
        <el-row style="display: flex">
          <el-col :span="2" style="margin-right: 15px">
        <div class="align-center">
          <svg-icone v-if="icone" :height="50" :width="50" :icone="icone" :fill="estilo.aplicacao.corPrimariaAplicacao"/>
        </div>
          </el-col>
          <el-col :span="9">
            <div class="align-text">
            <div class="card-contatos-title">
              <span class="card-title-2">{{superContato.descricao}}</span><br>
            </div>
            <div class="card-contatos-text">
              <span class="card-text">{{itens.descricao}}</span>
            </div>
            </div>
          </el-col>
          <el-col :span="12">
          <div>
            <el-row class="height-row" :style="heightRow()">
            <el-col :span="12" style="height: 44px" v-for="(item, index) in contatosSuperContato" :key="index">
              <div @click="iniciarConversa(item.value)" style="width: 80px" v-if="item.tipo === 'whatsapp' ">
                <el-button :style="botaoStyle()" class="button-actions-2"><svg-icone :height="15" icone="icon_mini_whatsapp" :cor="'#FFFFFF'"/></el-button><br>
                <span style="left: 34px" :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title">Conversar</span>
              </div>
              <div style="width: 80px" v-if="item.tipo === 'telefone' ">
                <a style="color: #FFFFFF; text-decoration: none" :href="`tel:+${item.value}`">
                  <el-button  :style="botaoStyle()" class="button-actions-2"><svg-icone icone="icon_mini_phone" :height="15" :cor="'#FFFFFF'"/></el-button><br>
                  <span style="left: 34px" :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title">{{ item.value }}</span>
                </a>
              </div>
              <div style="width: 80px" v-if="item.tipo === 'link' ">
                <a style="text-decoration: none" :href="`${item.value}`" target="_blank">
                  <el-button :style="botaoStyle()" class="button-actions-2"><svg-icone style="top: 1px; position: relative;" icone="icon_mini_open_new" :height="15" :cor="'#FFFFFF'"/></el-button><br>
                  <span style="left: 34px" :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title">Abrir link</span>
                </a>
              </div>
              <div style="width: 80px" v-if="item.tipo === 'email' ">
                <a style="text-decoration: none" v-if="item.tipo  === 'email'" :href="`mailto: ${item.value}`">
                  <el-button :style="botaoStyle()" class="button-actions-2"><svg-icone icone="icon_mini_email" :height="15" :cor="'#FFFFFF'"/></el-button><br>
                  <span style="left: 34px" :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title"> email</span>
                </a>
              </div>
            </el-col>
            <div style="cursor: pointer" @click="openMap" v-if="coordenadas.latitude && coordenadas.longitude" >
              <el-button class="button-actions-2" :style="botaoStyle()"><svg-icone icone="icon_mini_map" :height="15" :cor="'#FFFFFF'"/></el-button><br>
              <span style="left: 34px" :style="'color:' + estilo.aplicacao.corPrimariaAplicacao" class="button-title">ver Mapa</span>
            </div>
            </el-row>
          </div>
          <div>
          </div>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import Mapa from '@/components/mapa/Mapa'
export default {
  name: 'BoxCards',
  data () {
    return {
      open: false,
      superContato: {},
      contatosSuperContato: {},
      itens: [],
      coordenadas: {},
      dataMap: {},
      mapConfig: {
        showHeader: true,
        showCardInfo: true,
        showActions: true,
        height: '634px',
        zoom: 10,
        gestureHandling: 'greedy'
      }
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('Login', ['agenteRelacionamento']),
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    parametros () {
      return this.funcionalidade.parametros
    },
    atendentePrincipal () {
      if (this.agenteRelacionamento) {
        if (Object.keys(this.agenteRelacionamento).length) {
          return this.agenteRelacionamento
        }
      }
      return false
    },
    icone () {
      return this.superContato.icone
    }
  },
  methods: {
    botaoStyle () {
      return `background-color: ${this.estilo.botaoPrincipal.corBotaoPrincipal};
      color: ${this.estilo.botaoPrincipal.corTextoBotaoPrincipal}`
    },
    openMap () {
      this.open = true
      this.$emit('openMap')
    },
    closeMap () {
      this.open = false
      this.$emit('closeMap')
    },
    heightRow () {
      if ((this.contatosSuperContato.length > 2) || (this.contatosSuperContato.length === 2 && this.coordenadas.longitude)) {
        return `left: 33px; margin-top: 6px;`
      }
    },
    iniciarConversa (numero) {
      window.open('https://wa.me/55' + numero)
    },
    cardStyle () {
      return `background-color: ${this.estilo.aplicacao.corPrimariaAplicacao}14;`
    },
    async init () {
      let result = await this.apiFuncionalidade.lista({ loading: true })
      this.superContato = result.data.find(contato => contato.super_contato === 1)
      if (this.superContato) {
        this.itens = this.superContato.itens[0]
        this.contatosSuperContato = this.superContato.itens[0].contatos
        this.coordenadas = { latitude: this.itens.latitude, longitude: this.itens.longitude }
        let lat = parseFloat(this.coordenadas.latitude)
        let lng = parseFloat(this.coordenadas.longitude)
        this.locations = [{
          coordenadas: [{ lat: lat, long: lng }],
          endereco: this.itens.endereco,
          descricao: this.superContato.descricao
        }]
      }
    }
  },
  components: {
    Mapa
  },
  async created () {
    await this.init()
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.card-contatos-image {
  border: 1px solid #006FB933;
  border-radius: 50px;
}
.height-row {
  left: 33px;
  margin-top: 25px;
}
.card-title {
  font-weight: 600;
  font-size: 16px;
  display: block;
  line-height: 22px;
  font-family: "Open Sans" SansSerif;
}
.card-contatos {
  width: 606px;
  height: 110px;
  border-radius: 10px;
  display: inline-block;
  border: none;
  box-shadow: none;
  margin-bottom: 10px;
}
.card-contatos-title {
  width: 256px;
  margin-left: 2px;
  max-height: 40px;
  overflow: hidden;
  display: flex;
}
.card-title-2 {
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 216px;
  line-height: 22px;
}
.card-atendente-text {
  font-size: 14px;
  margin: 0;
  line-height: 25px;
}
.card-text {
  font-size: 14px;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 216px;
}
.button-actions {
  height: 30px;
  width: 30px;
  padding: 5px 3px;
  border-radius: 50px;
  display: block;
  border: none;
}
.button-actions-2 {
  height: 30px;
  width: 30px;
  padding: 5px 3px;
  border-radius: 50px;
  margin-left: auto;
  margin-right: auto;
  border: none;
  display: inline;
}
.button-title {
  text-transform: uppercase;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  position: relative;
  bottom: 25px;
  left: 34px;
  color: rgb(0, 153, 93);
}
.flex {
  display: flex;
  justify-content: center;
}
.actions {
  width: 100%;
}
.itens {
  width: 120px;
}

.card-contatos-text {
  width: 256px;
  margin-bottom: 2px;
  margin-left: 2px;
  overflow: hidden;
}
.svg-div {
  margin-bottom: 15px;
  margin-left: 2px;
  height: 45px;
}
.lista-2-botoes {
  width: 100%;
  border-radius: 50px;
  padding: 9px 0;
  font-size: 10px;
  border: none;
}
.align-svg {
  position: relative;
  top: 2px;
  right: 4px;
}
.side-by-side {
  display: flex;
  width: 100%
}
.align {
  display: inline-flex;
  width: 100%
}
.align-center {
  position: relative;
  top: 12px;
}
.align-text {
  position: relative;
  margin-top: 7%;
}
.align-buttons {
  position: relative;
  top: 25px;
  display: flex;
  justify-content: space-between;
  left: 27px;
}
.el-col-12 {
  width: 48%;
}
</style>
